module.exports = __webpack_public_path__ + "static/img/12.5d1b625.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/12.png
// module id = 7ClH
// module chunks = 0